<template>
    <div :class="{ 'header':true, 'fade-in':true }" @mouseenter="show = true" @mouseleave="show = false">
        <div class="header-icon">
            <div class="line"></div>
            <div class="text">能源 安防 环境 运维<br/>智慧工业集成商</div>
        </div>
        <div class="menu">
            <div
                v-for="item in menuList"
                :key="item.path"
                class="menu-item-wrapper"
                @click="handleClick(item.path, item.href)"
            >
                <div 
                    :class="{ 'menu-item':true, 'selected': false && ( $route.matched.length > 2 ? $route.matched[1].path === item.path : $route.path === item.path )}"
                >
                    <span>{{  item.title }}</span>
                </div>
            </div>
        </div>
        <div>
           
        </div>
    </div>
</template>

<script> 
    import { markAction } from '@/api/global.js';
    const menuList = [
        { title:'首页', path:'/home', href:'#home' }, { title:'能碳平台', path:'/ec' }, { title:'iFMCS 厂务平台', path:'/ifmcs' },
        { title:'生态合作', path:'/teamwork', href:'#teamwork' }, { title:'动态', path:'/news', href:'#news' }
    ];
    export default {
        data(){
            return {
                show:false,
                menuList,
            }
        },
        methods:{
            handleClick(path, href){
                if ( path === '/ec') {
                    // markAction({ operationType:'进入开放平台' });
                    window.open('http://ec.ifmcs.com', '__blank');
                } else if ( path === '/ifmcs') {
                    window.open('http://fm.ifmcs.com', '__blank')
                } else {
                    if ( href ){
                        const el = document.querySelector(href);
                        if (el) el.scrollIntoView({ behavior: 'smooth' })
                    }
                }
            },
            handleGo(){
                markAction({ operationType:'进入厂务' });
                window.open('http://iot.ifmcs.com', '__blank');
            }
        }
    }
</script>
<style>
.header {
    width:100%;
    height:80px;
    position:fixed;
    top:0;
    left:0;
    display:flex;
    align-items: center;
    background:transparent;
    border-bottom:1px solid rgba(255, 255, 255, 0.29); 
    justify-content: center;
    z-index:100;
    transition:background 0.3s;
}

.entry {
    width:160px;
    height:100%;
    display:flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color:#fff;
    background:transparent;
    border-left:1px solid rgba(255, 255, 255, 0.29); 
    transition:all 0.3s;
    cursor:pointer;
    position:relative;
}
.menu {
    display:flex;
    align-items: center;
    height:100%;
    /* transition: all 0.3s; */
}
.menu .menu-item-wrapper {
    height:100%;
}
.menu .menu-item {
    height:100%;
    padding:0 40px;
    color:rgba(255, 255, 255, 0.6);
    cursor: pointer;
    display:flex;
    align-items: center;
    transition:all 0.3s;
}

.menu .menu-item.selected {
    color:#fff;
}
.header-icon {
    width:120px;
    height:30px;
    /* width:138px;
    height:36px; */
    position:absolute;
    left:40px;
    top:50%;
    transform:translateY(-50%);
    background-image:url('../../assets/logo_white.png');
    background-repeat: no-repeat;
    background-size: contain;
}
.header-icon .line {
    position:absolute;
    top:0;
    right:-1rem;
    width:1px;
    height:100%;
    background: #d9d9d9;
}
.header-icon .text {
    position:absolute;
    top:50%;
    transform:translateY(-50%);
    right:-10rem;
    line-height:20px;
    color:rgba(255, 255, 255, 0.6);
    font-size:0.87rem;
}
.app-container.show-menu .header, .header.fade-in {
    background:rgba(255, 255, 255, 0.8);
    box-shadow:0 0 50px rgba(0,0,0,.05);
    border-bottom:none;
    backdrop-filter:saturate(180%) blur(20px);
}
.app-container.show-menu .menu-item, .header.fade-in .menu-item {
    color:#99A0AE;
}
.app-container.show-menu .menu-item:hover, .header.fade-in .menu-item:hover {
    color:#335CFF;
}
.app-container.show-menu .menu-item.selected, .header.fade-in .menu-item.selected {
    color:#335CFF;
}
.app-container.show-menu .header-icon .text, .header.fade-in .header-icon .text {
    color:#525866;
}
.app-container.show-menu .entry, .header.fade-in .entry {
    background:#335CFF;
}
.app-container.show-menu .header-icon, .header.fade-in .header-icon {
    background-image:url('../../assets/logo_color.png');
}
</style>